import React, { Component } from 'react'
import { Hero } from '../../components/Layout'
import { TableUsers, LicensesManager, ExportUsersButton } from './components'
import { types } from '../../store'
import { Button, Input, Icon, Menu, Checkbox, Dropdown, message } from 'antd'

class Users extends Component {
  componentDidMount () {
    const { getUsers, getGroups, getDivisions } = this.props
    getUsers()
    getGroups()
    getDivisions()
  }

  handleSearch = (e) => {
    const { updateTable } = this.props

    updateTable({
      searchString: e.target.value,
      keys: [],
      rows: []
    })
  }

  handleRole = (e) => {
    const { updateTable, table: { searchRoles } } = this.props

    if (e.target.checked === true) {
      updateTable({
        searchRoles: [
          ...searchRoles,
          e.target.name.toUpperCase()
        ],
        keys: [],
        rows: []
      })
    }

    if (e.target.checked === false) {
      updateTable({
        searchRoles: [
          ...searchRoles.filter(item => item !== e.target.name.toUpperCase())
        ],
        keys: [],
        rows: []
      })
    }
  }

  handleGroup = (e, id) => {
    const { updateTable, table: { searchGroups } } = this.props

    if (e.target.checked === true) {
      updateTable({
        searchGroups: [
          ...searchGroups,
          id
        ],
        keys: [],
        rows: []
      })
    }

    if (e.target.checked === false) {
      updateTable({
        searchGroups: [
          ...searchGroups.filter(item => item !== id)
        ],
        keys: [],
        rows: []
      })
    }
  }

  activateUser = () => {
    const { updateUserById, updateTable, table: { rows } } = this.props

    const params = {
      ...rows[0],
      activateStatus: true,
      groupIds: rows[0].groups.map(group => group.id)
    }

    updateUserById(rows[0].id, params).then(() => {
      updateTable({
        keys: [],
        rows: []
      })
    }).catch(response => {
      message.error(response.data.error.message)
    })
  }

  deactivateUser = () => {
    const { updateUserById, updateTable, table: { rows } } = this.props

    const params = {
      ...rows[0],
      activateStatus: false,
      groupIds: rows[0].groups.map(group => group.id)
    }

    updateUserById(rows[0].id, params).then(() => {
      updateTable({
        keys: [],
        rows: []
      })
    }).catch(response => {
      message.error(response.data.error.message)
    })
  }

  render () {
    const { user, users, table, table: { rows }, group, updateTable, setModal } = this.props
    const selectedCount = rows.length

    const filterRole = (
      <Menu>
        <Menu.Item><Checkbox name='USER' onChange={this.handleRole}>User</Checkbox></Menu.Item>
        <Menu.Item><Checkbox name='ORGANIZATION_ADMIN' onChange={this.handleRole}>Administrator</Checkbox></Menu.Item>
      </Menu>
    )

    const filterGroups = (
      <div className='groups-dropdown'>
        <div className='groups-dropdown__button'>
          <Button type='dashed' onClick={() => setModal(types.MODAL_GROUP_CREATE, true)}><Icon type='plus' /> New Group</Button>
        </div>
        <div className='groups-dropdown__list'>
          { group.list.length
            ? group.list.map((group, index) =>
              <div key={group.id} className='groups-dropdown__item'>
                <Checkbox onChange={(e) => this.handleGroup(e, group.id)} >{ group.name }</Checkbox>
                <div className='groups-dropdown__controls'>
                  <Icon type='edit' onClick={() => setModal(types.MODAL_GROUP_EDIT, { status: true, id: group.id, name: group.name })} />
                  <Icon type='delete' onClick={() => setModal(types.MODAL_GROUP_DELETE, { status: true, id: group.id })} />
                </div>
              </div>
            )
            : <span>No Groups</span> }
        </div>
      </div>
    )

    return (
      <div className='app__content'>
        <div className='content__hero'>
          <Hero
            heading='User Management'
            content={<LicensesManager users={users} />} />
        </div>
        <div className='content__page'>
          <div className='container'>
            <div className='page'>
              <div className='page-content page__content'>
                <div className='page-content-head page-content__head'>
                  <div className='page-content-head__controls'>
                    <div className='page-content-head__control'>
                      <Button type='indigo' onClick={() => setModal(types.MODAL_USER_CREATE, true)}>New User</Button>
                    </div>
                  </div>
                  <div className='page-content-head__controls'>
                    <div className='page-content-head__control'>
                      <Dropdown overlay={filterRole} trigger={['click']} placement='bottomLeft'>
                        <Button style={{ marginLeft: 8 }}>
                          Role <Icon type='down' />
                        </Button>
                      </Dropdown>
                    </div>
                  </div>
                  <div className='page-content-head__controls'>
                    <div className='page-content-head__control'>
                      <Dropdown overlay={filterGroups} trigger={['click']} placement='bottomLeft'>
                        <Button style={{ marginLeft: 8 }}>
                          Groups <Icon type='down' />
                        </Button>
                      </Dropdown>
                    </div>
                  </div>
                  { selectedCount === 1
                    ? <div className='page-content-head__controls'>
                      <div className='page-content-head__control'>
                        <Button type='dashed' onClick={() => setModal(types.MODAL_USER_EDIT, { status: true, user: rows[0] })}>Edit</Button>
                      </div>
                    </div> : '' }
                  { selectedCount >= 1
                    ? <div className='page-content-head__controls'>
                      <div className='page-content-head__control'>
                        <Button type='dashed' icon='delete' onClick={() => setModal(types.MODAL_USER_DELETE, true)}>Delete</Button>
                      </div>
                    </div> : '' }
                  <div className='page-content-head__controls'>
                    <div className='page-content-head__control'>
                      <ExportUsersButton>Export CSV</ExportUsersButton>
                    </div>
                  </div>
                  <div className='page-content-head__controls page-content-head__controls_last'>
                    <div className='page-content-head__control page-content-head__control_last'>
                      <Input prefix={<Icon type='search' style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder='Search' onKeyUp={this.handleSearch} />
                    </div>
                  </div>
                </div>

                <div className='page-content__table'>
                  <TableUsers
                    loading={user.listFetching}
                    users={users}
                    table={table}
                    group={group}
                    updateTable={updateTable}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Users



// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx